import { render, staticRenderFns } from "./UserWalletTransactions.vue?vue&type=template&id=16f8c98c&scoped=true&"
import script from "./UserWalletTransactions.vue?vue&type=script&lang=js&"
export * from "./UserWalletTransactions.vue?vue&type=script&lang=js&"
import style0 from "./UserWalletTransactions.vue?vue&type=style&index=0&id=16f8c98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f8c98c",
  null
  
)

export default component.exports